module.exports = __webpack_public_path__ + "static/media/games.01c3136c.svg";